import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export const labels = (state = initialState, action) => {
  switch (action.type) {
    case types.LOAD_LABEL_SUCCESS:
      return { ...state, labels: action.labels };

    case types.CREATE_LABEL_SUCCESS:
      return {
        ...state,
        labels: [...state.labels, { ...action.label }].sort(
          (a, b) => a.id - b.id // Sort by id alphabetically.
        )
      };

    case types.UPDATE_LABEL_SUCCESS:
      return {
        ...state,
        labels: [
          ...state.labels.filter((l) => l.id !== action.label.id),
          { ...action.label }
        ].sort(
          (a, b) => a.id - b.id // Sort by id alphabetically.
        )
      };

    case types.DELETE_LABEL_SUCCESS:
      return {
        ...state,
        labels: [...state.labels.filter((l) => l.id !== action.labelId)]
      };

    default:
      return state;
  }
};

export const label = (state = initialState.label, action) => {
  switch (action.type) {
    case types.GET_LABEL_SUCCESS:
      return action.label;

    default:
      return state;
  }
};

export const savingLabel = (state = initialState.savingLabel, action) => {
  switch (action.type) {
    case types.SAVING_LABEL:
      return action.savingLabel;

    default:
      return state;
  }
};

export const labelToDelete = (state = initialState.labelToDelete, action) => {
  switch (action.type) {
    case types.REQUEST_LABEL_ID:
      return action.labelToDelete;

    default:
      return state;
  }
};
